import { useWorkspace } from '@/features/workspaces/hooks';
import { AudiencesIcon } from '@/lib';
import { useGetWorkspaceMetricsQuery } from '@/services/endpoints/metrics';
import { FC } from 'react';
import { HomeDataSection } from '../../common';
import { HomeAudiencesChartWidget } from './HomeAudiencesChartWidget';

export const HomeAudienceSection: FC = () => {
  const workspace = useWorkspace();
  const { data: metrics, isFetching } = useGetWorkspaceMetricsQuery(
    { workspaceId: workspace.id },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <HomeDataSection
      icon={<AudiencesIcon />}
      title={'home.audienceTitle'}
      totalLabel={'home.audienceTotalLabel'}
      totalValue={metrics?.totalAudienceSize}
      chart={<HomeAudiencesChartWidget />}
      createPath={'/audiences/create'}
      creteButtonText={'home.audienceCreateButtonText'}
      isLoading={isFetching}
    />
  );
};
